import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 2,
  class: "flex items-center bg-white text-[#7E7E7E] border border-[#7E7E7E] rounded-md px-[30px] py-[10px]"
}
const _hoisted_3 = { key: 3 }
const _hoisted_4 = ["uk-toggle"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "uk-modal-dialog uk-modal-body uk-margin-auto-vertical" }
const _hoisted_7 = { class: "uk-flex uk-flex-center uk-flex-middle gap-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$setup.props.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "txt__notoR14 relative group flex items-center bg-[#749F54] !text-white rounded-md px-[30px] py-[10px] transition-all duration-200 cursor-not-allowed",
        onMouseenter: $setup.showTooltip,
        onMouseleave: $setup.hideTooltipWithDelay
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "material-symbols-outlined" }, "add", -1 /* CACHED */)),
        _cache[4] || (_cache[4] = _createTextVNode("フォロー", -1 /* CACHED */)),
        _createElementVNode("div", {
          class: _normalizeClass(["txt__notoR14 text-left absolute transition-all duration-200 bg-[#7EA35C] top-0 right-0 -translate-y-[125%] rounded-[20px] p-[24px] w-[270px] shadow-lg z-50", $setup.isTooltipVisible ? 'visible opacity-100 pointer-events-auto' : 'invisible opacity-0 pointer-events-none']),
          onMouseenter: $setup.showTooltip,
          onMouseleave: $setup.hideTooltipWithDelay
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("p", null, "フォロー機能は会員限定です。", -1 /* CACHED */)),
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "ログインして新着通知を受け取りましょう！", -1 /* CACHED */)),
          _createElementVNode("a", {
            class: "!underline block !text-white rounded-md px-[30px] pt-[10px] text-center font-bold",
            href: `${$setup.baseUrl}/mypage/login?redirect=${encodeURIComponent($setup.currentPath)}`
          }, "[ログイン/新規登録へ]", 8 /* PROPS */, _hoisted_1),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute left-1/2 -bottom-[10px] w-5 h-5 bg-[#7EA35C] rotate-45 -translate-x-1/2" }, null, -1 /* CACHED */))
        ], 34 /* CLASS, NEED_HYDRATION */)
      ], 32 /* NEED_HYDRATION */))
    : ($setup.props.isLoggedIn && $setup.isFollowing === false)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "txt__notoR14 flex items-center bg-[#749F54] text-white rounded-md px-[30px] py-[10px] transition-all duration-200 hover:!bg-[#7EA35C] active:!bg-[#446F23]",
          onClick: _withModifiers($setup.handleFollow, ["prevent"])
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "material-symbols-outlined" }, "add", -1 /* CACHED */),
          _createTextVNode("フォロー", -1 /* CACHED */)
        ])))
      : ($setup.isFollowing === true && $setup.props.mode === 'projectDetail')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[6] || (_cache[6] = [
            _createElementVNode("span", { class: "material-symbols-outlined" }, "check", -1 /* CACHED */),
            _createTextVNode("フォロー中", -1 /* CACHED */)
          ])))
        : ($setup.isFollowing === true && $setup.props.mode === 'mypage')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "txt__notoR14 flex items-center bg-white text-[#7E7E7E] border border-[#7E7E7E] rounded-md px-[30px] py-[10px] cursor-pointer",
                "uk-toggle": `target: #unfollowModal__${$setup.props.businessId}`
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "check", -1 /* CACHED */),
                _createTextVNode("フォロー中", -1 /* CACHED */)
              ]), 8 /* PROPS */, _hoisted_4),
              _createElementVNode("div", {
                class: "uk-flex-top",
                id: `unfollowModal__${$setup.props.businessId}`,
                "uk-modal": ""
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "uk-modal-title txt__notoSB18 !mb-10" }, "フォローを解除しますか？", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("button", {
                      class: "flex-1 uk-modal-close border border-[#7E7E7E] rounded-md px-[30px] py-[10px]",
                      type: "button"
                    }, "キャンセル", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      class: "flex-1 uk-modal-close bg-[#F03E53] text-white rounded-md px-[30px] py-[10px]",
                      onClick: _withModifiers($setup.handleUnfollow, ["prevent"]),
                      type: "button"
                    }, "解除")
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_5)
            ]))
          : _createCommentVNode("v-if", true)
}